import React from 'react';

import { Box, Text, Heading } from '@primer/components'

import { Link } from "react-router-dom";

import { useProduct } from '../../hooks/useProduct'


export default function(props) {
  const productDetails = useProduct()
  const shieldUrl = productDetails.id === 'djangodoctor'
    ? `https://img.shields.io/badge/django%20doctor-${props.count}-007ec6`
    : `https://img.shields.io/badge/code%20review%20doctor-${props.count}-007ec6`
  return (
    <Box>
      <Box className="mb-6">
        <Heading>Badge</Heading>
        <Box className="mt-3 mb-3">
          <img src={shieldUrl} alt="badge" />
        </Box>
        <Text as="p" className="f3 mb-3">To add the {productDetails.name} badge to your readme file copy and paste this markdown:</Text>
        <Text as="pre" className="f3 mb-3" style={{whiteSpace: 'pre-line'}}>
            {`[![${productDetails.name}](https://${productDetails.domain}/${props.owner}/${props.repository}/${props.branch}.svg)](https://${productDetails.domain}/@${props.owner}/${props.repository})`}
        </Text>
      </Box>
      <Box className="mb-6">
        <Heading>Configuring checks</Heading>
        <Text as="p" className="f3 mb-3">{productDetails.name} checks the most common coding anti-patterns. Use a <code className="f3">pyproject.toml</code> file to control which checks are ran. <Link to="/config">Read about configuring {productDetails.name}</Link>.</Text>
      </Box>

      { !props.isInstalled && (
          <Box className="mb-6">
            <Heading>Protect your Pull Requests</Heading>
            <Text as="p" className="f3 mb-3">{productDetails.name} can also review your Pull Requests with our <a href="https://github.com/marketplace/django-doctor/">GitHub Pull Request bot</a>.</Text>
          </Box>
        )
      }
    </Box>
  )
}
